import { render, staticRenderFns } from "./MetionTextArea.vue?vue&type=template&id=f968397c"
import script from "./MetionTextArea.vue?vue&type=script&lang=js"
export * from "./MetionTextArea.vue?vue&type=script&lang=js"
import style0 from "./MetionTextArea.vue?vue&type=style&index=0&id=f968397c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports